import OPE from 'js/on-page-editing';

import ContentArea from 'components/content-area/ContentArea';
import ContentContainer from 'components/content-container/ContentContainer';

import { IPageLinksBlock } from 'source/NFR.types';

const PageLinksBlock: React.FC<IPageLinksBlock> = ({
  highlightedLinks,
  linkLists = [],
  onPageEditing = {},
  text,
  title
}) => {
  return (
    <div className="page-links-block">
      <ContentContainer className="page-links-block--content">
        <div className="page-links-block--header">
          {title && <h2 {...OPE(onPageEditing.title)}>{title}</h2>}
          {text && <p {...OPE(onPageEditing.text)}>{text}</p>}
        </div>

        {highlightedLinks && (
          <ContentArea
            className="page-links-block--links"
            enableElementSizing={false}
            theme="threeColumns"
            {...highlightedLinks}
          />
        )}

        {linkLists?.map(linkList => (
          <ContentArea
            className="page-links-block--links"
            enableElementSizing={false}
            key={linkList.id}
            theme="fourColumns"
            {...linkList.links}
          />
        ))}
      </ContentContainer>
    </div>
  );
};

PageLinksBlock.displayName = 'PageLinksBlock';

export default PageLinksBlock;
